import { isPlatformBrowser } from "@angular/common";
import { Component, inject, OnInit, PLATFORM_ID } from "@angular/core";

export const FORGOT_PASSWORD = 'forgot password';

@Component({
    selector: 'app-forgot-password-callback',
    template: '<h1>Redirecting... Please wait</h1>'
})
export class ForgotPasswordCallbackComponent implements OnInit {
    private readonly platformId = inject(PLATFORM_ID);
    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            window.parent.postMessage(FORGOT_PASSWORD);
        }
    }
}